export default (entityOrId) => entityOrId && String(entityOrId._id || entityOrId);
